<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Button,
        Heading,
        InboxButton,
        Link,
        List,
        Paragraph,
        SESSION_USER,
        SESSION_API,
    } from '@smatch/cassiopeia-web-components';

    // STYLING
    import 'tailwindcss/tailwind.css';

</script>

<Heading size = 'md'>Resend Confirmation Email</Heading>

{#if $SESSION_USER !== null }

    {#await SESSION_API.sendEmailConfirmationUrl({ email: $SESSION_USER.email }) then response}

        {#if 'error' in response}

            <Paragraph>
                Unfortunately we encountered an error in resending the confirmation email.
                Please get in touch with your account LockManager.
            </Paragraph>

        {:else}

            <Paragraph>
                We've sent a confirmation email to <strong>{ $SESSION_USER.email }</strong>.
            </Paragraph>

            <Paragraph>Please check your inbox (and possibly your spam folder) for the next steps.</Paragraph>

            <InboxButton email = { $SESSION_USER.email } />

        {/if}

    {/await}

{/if}

<div class = 's8-list'>

    <List mode = 'simple'>
        <li><Link url = '#onboarding/confirmation-update'>Change Email Address</Link></li>
    </List>

</div>

<div class = 's8-footer'>

    <Button
        type = 'button'
        label = 'Cancel'
        color = 'neutral'
        css = 'w-full'
        url = '#onboarding'
    />

</div>

<style lang='postcss'>

    div.s8-list {
        margin-top: 40px;
    }

    div.s8-footer {
        display: flex;
        column-gap: 10px;
        flex-grow: 1;
        align-items: flex-end;
    }

</style>